import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { ImageComponent } from './general/image.component.js';
import { AvatarModule } from '../ui/avatar/index.js';
import { AvatarComponent } from './general/avatar.component.js';

@NgModule({
	imports: [CommonModule, NgOptimizedImage, AvatarModule],
	declarations: [ImageComponent, AvatarComponent],
	exports: [ImageComponent, AvatarComponent]
})
export class ImagesModule {}
